import { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { ChevronRight, Compass } from 'lucide-react';
import { Barre } from './constantes';

// Tuile d'accueil (centre, RP, formateur si l'équipe a accès) : avancement des stagiaires dans le guide BC1 / BC2
export const TuileGuide = () => {
  const [r, setR] = useState(null);
  const navigate = useNavigate();
  useEffect(() => { axios.get('/guide-bpjeps/resume').then(({ data }) => setR(data)).catch(() => setR(null)); }, []);
  if (!r) return null;

  return (
    <button type="button" onClick={() => navigate('/guide-bc1-bc2?onglet=suivi')} data-testid="tuile-guide-bc"
      className="group w-full rounded-xl border border-slate-200 bg-white p-5 text-left shadow-sm transition-shadow hover:shadow-md">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="flex items-center gap-2 font-semibold text-[#0F172A]"><Compass className="h-5 w-5 text-[#0E7C74]" /> Guide BC1 / BC2</p>
        <span className={`rounded-full px-2.5 py-0.5 text-xs font-semibold ${r.ouvert_stagiaires ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100 text-slate-500'}`} data-testid="tuile-guide-etat">
          {r.ouvert_stagiaires ? 'Ouvert aux stagiaires' : 'Fermé aux stagiaires'}
        </span>
      </div>
      <div className="mt-4 grid gap-4 sm:grid-cols-[auto_1fr] sm:items-end">
        <div>
          <p className="text-3xl font-bold text-[#0F172A]" data-testid="tuile-guide-commences">{r.commences}<span className="text-lg font-medium text-slate-400"> / {r.total}</span></p>
          <p className="text-xs text-slate-500">stagiaires ont commencé · {r.acces} ont accès</p>
        </div>
        <div>
          <p className="text-sm text-slate-600">Avancement moyen <b className="text-[#0F172A]" data-testid="tuile-guide-moyenne">{r.moyenne} %</b></p>
          <p className="text-xs text-slate-400" data-testid="tuile-guide-blocs">BC1 {r.moyennes.BC1} % · BC2 {r.moyennes.BC2} %</p>
          <Barre pret={r.moyenne} total={100} couleur="bg-[#0E7C74]" className="mt-1.5" testId="tuile-guide-barre" />
        </div>
      </div>
      <p className="mt-3 flex items-center gap-1 text-xs font-semibold text-[#0E7C74]">Voir le suivi des stagiaires <ChevronRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" /></p>
    </button>
  );
};
